import { CmsComponent } from '@stnimmerhome/webinterface-data-model'

export function UnknownComponent({data}: {data: CmsComponent}) {
    return <>
    Component of unknown type {data.type}
    </>
}

export default UnknownComponent;